import { useEffect, useState } from 'react'
import { useNVAlertsContext } from '@nv/contexts'
import styles from './NVAlertsBanner.module.scss'

export const NVAlertsBanner = () => {
  const { alert, hideAlert } = useNVAlertsContext()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (!alert.isOpen) return

    setIsVisible(false)

    const slideDownTimer = setTimeout(() => {
      setIsVisible(true)
    }, 1)

    const hideTimer = setTimeout(() => {
      setIsVisible(false)
    }, 3500)

    const resetAlertTimer = setTimeout(() => {
      hideAlert()
    }, 3500 + 500) // 500ms = css transition

    return () => {
      clearTimeout(slideDownTimer)
      clearTimeout(hideTimer)
      clearTimeout(resetAlertTimer)
    }
  }, [alert.isOpen, hideAlert])

  // Determine dynamic background based on type
  const backgroundStyle = {
    ...(alert.type === 'success' && { backgroundColor: 'var(--green-100)' }),
    ...(alert.type === 'error' && { backgroundColor: 'var(--red-100)' }),
    ...alert.style,
  }

  return (
    <div className={[styles['container'], isVisible && styles['container--visible']].filter(Boolean).join(' ')} style={backgroundStyle}>
      <div className={styles['extend-info']}>
        {alert.isOpen && (
          <div className={styles['content']}>
            {alert.icon} {alert.message}
          </div>
        )}
      </div>
    </div>
  )
}
